import React, { useState } from "react";
import { BiMessage } from "react-icons/bi";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import { LinkData } from "../assets/data/dummydata";
import LogoImg from "../assets/images/ceva-piura-log.png";

export const Header = () => {
  const [open, setOpen] = useState(false);

  const enviarMensaje = () => {
    const numeroTelefono = "51967575397";
    const mensaje = "Hola, deseo más información.";
    const url = `https://wa.me/${numeroTelefono}?text=${encodeURIComponent(
      mensaje
    )}`;

    window.open(url, "_blank");
  };

  return (
    <>
      <header className="bg-white sticky top-0 left-0 z-50 w-full shadow-md">
        {/* NAVBAR */}
        <div className="py-4">
          <div className="container mx-auto px-4 flex justify-between items-center">
            {/* LOGO */}
            <a href="/">
              <img
                src={LogoImg}
                alt="logo"
                className="h-14 md:h-16 object-contain"
              />
            </a>

            {/* MENÚ */}
            <nav className={open ? "mobile-view" : "desktop-view"}>
              <ul className="flex items-center gap-7">
                {LinkData.map((link) => (
                  <li key={link.id} onClick={() => setOpen(false)}>
                    <NavLink
                      to={link.url}
                      className={({ isActive }) =>
                        isActive
                          ? "text-blue-600 font-semibold text-[17px]"
                          : "text-[17px] hover:text-blue-600 transition"
                      }
                    >
                      {link.title}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>

            {/* BOTONES */}
            <div className="flex items-center gap-4">
              <button
                onClick={enviarMensaje}
                className="hover:text-blue-600 transition"
              >
                <BiMessage size={26} />
              </button>

              <button
                onClick={enviarMensaje}
                className="hidden lg:flex font-medium hover:text-blue-600 transition"
              >
                Enviar Mensaje
              </button>

              <button
                className="lg:hidden"
                onClick={() => setOpen(!open)}
              >
                <HiOutlineMenuAlt1 size={28} />
              </button>
            </div>
          </div>
        </div>

        {/* 🔥 BARRA MÁS GRUESA Y SIN MARCO */}
        <div className="w-full h-[8px] flex">
          <div className="w-1/3 bg-red-600"></div>
          <div className="w-1/3 bg-yellow-400"></div>
          <div className="w-1/3 bg-blue-700"></div>
        </div>
      </header>
    </>
  );
};